// extracted by mini-css-extract-plugin
export default {"tabs":"PointsOfInterestDialog-module__tabs__I6Gap","selection":"PointsOfInterestDialog-module__selection__bWZl7"};